import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Navbar({ user, cartCount, onLogout, searchTerm, onSearchChange, selectedCategory }) {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileMenuClosing, setMobileMenuClosing] = useState(false);

  const handleSearchChange = (e) => {
    if (onSearchChange) {
      onSearchChange(e.target.value);
    }
  };

  const closeMobileMenu = () => {
    setMobileMenuClosing(true);
    setTimeout(() => {
      setMobileMenuOpen(false);
      setMobileMenuClosing(false);
    }, 300);
  };

  return (
    <nav className="navbar">
      <div className="top-bar">
        <div className="top-bar-content">
          <div className="top-bar-left">BIG SALE - Premium Auto Parts</div>
          <div className="top-bar-right">Pakistan (PKR Rs)</div>
        </div>
      </div>
      
      <div className="navbar-content">
        <button 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          style={{display: 'none', background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#212121'}}
        >
          ☰
        </button>
        
        <div className="logo" onClick={() => navigate('/')} style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
          <img 
            src="/logo.png" 
            alt="Loom Logo" 
            style={{height: '60px', width: 'auto', maxWidth: '200px'}}
          />
        </div>
        
        <div className="navbar-search">
          <input 
            type="text" 
            placeholder="Search our store" 
            value={searchTerm || ''}
            onChange={handleSearchChange}
          />
          <button type="button">Search</button>
        </div>
        
        <div className="navbar-icons">
          <button onClick={() => navigate('/cart')} className="cart-btn" title="Cart">
            🛒
            {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
          </button>
          {user ? (
            <>
              <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="user-icon-btn" title="Account">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="8" r="5"/>
                  <path d="M20 21a8 8 0 1 0-16 0"/>
                </svg>
              </button>
              {user.role === 'admin' && (
                <button onClick={() => navigate('/admin')} title="Admin">⚙️</button>
              )}
            </>
          ) : (
            <button onClick={() => navigate('/login')} className="user-icon-btn" title="Login">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="8" r="5"/>
                <path d="M20 21a8 8 0 1 0-16 0"/>
              </svg>
            </button>
          )}
        </div>
      </div>
      
      <div className="bottom-nav">
        <div className="bottom-nav-content">
          <button className="categories-btn">
            <span>☰</span> {selectedCategory || 'ALL CATEGORIES'}
          </button>
          <div className="nav-menu">
            <button onClick={() => navigate('/')}>HOME</button>
            <button onClick={() => navigate('/about')}>ABOUT</button>
            <button onClick={() => navigate('/track')}>TRACK</button>
            <button onClick={() => navigate('/feedback')}>FEEDBACK</button>
            <button onClick={() => navigate('/contact')}>CONTACT</button>
          </div>
          <div className="navbar-contact">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
            </svg>
            <span>03217600273</span>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className={`mobile-menu-dark ${mobileMenuClosing ? 'closing' : ''}`}>
          <button className="menu-close-icon" onClick={closeMobileMenu}>×</button>
          
          <div className="menu-profile">
            <div className="profile-avatar">
              <img src="/logo.png" alt="Logo" />
            </div>
            <h3 className="profile-name">Loom Parts</h3>
            <p className="profile-email">info@loomparts.com</p>
          </div>
          
          <div className="menu-items-dark">
            <button onClick={() => {navigate('/'); closeMobileMenu();}} className="menu-item-dark">
              <span className="item-text">Home</span>
            </button>
            <button onClick={() => {navigate('/about'); closeMobileMenu();}} className="menu-item-dark">
              <span className="item-text">About</span>
            </button>
            <button onClick={() => {navigate('/track'); closeMobileMenu();}} className="menu-item-dark">
              <span className="item-text">Track Order</span>
            </button>
            <button onClick={() => {navigate('/cart'); closeMobileMenu();}} className="menu-item-dark">
              <span className="item-text">Cart</span>
              {cartCount > 0 && <span className="item-badge">{cartCount}</span>}
            </button>
            <button onClick={() => {navigate('/feedback'); closeMobileMenu();}} className="menu-item-dark">
              <span className="item-text">Feedback</span>
            </button>
            <button onClick={() => {navigate('/contact'); closeMobileMenu();}} className="menu-item-dark">
              <span className="item-text">Contact</span>
            </button>
          </div>
          
          <div className="menu-footer-dark">
            {user ? (
              <button onClick={() => {onLogout(); closeMobileMenu();}} className="signout-btn">
                Logout
              </button>
            ) : (
              <button onClick={() => {navigate('/login'); closeMobileMenu();}} className="signout-btn">
                Login
              </button>
            )}
          </div>
        </div>
      )}

      {mobileMenuOpen && (
        <div 
          onClick={closeMobileMenu}
          className={`mobile-overlay ${mobileMenuClosing ? 'closing' : ''}`}
        />
      )}
    </nav>
  );
}

export default Navbar;
